import './BlogPageBanner.scss';
import React from 'react';
import { cn } from '../../../common/utils/bem';
import { Button } from '@dataartdev/uikit/Button';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';
import { Typography } from '@dataartdev/uikit/Typography';
import { Picture } from '@dataartdev/uikit/Picture';
import { Banner } from '../pages/blog_page_models';
import { prepareButtonAttrs } from '../../../common/utils/prepareButtonAttrs';
import { GridItem } from '@dataartdev/uikit/Grid';
import { SubscriptionForm } from './SubscriptionForm';

export const cnBlogPageBanner = cn('BlogPageBanner');

export const BlogPageBanner: React.FC<Banner> = props => {
  const { picture, text, title, button, isForm, color = '#ffde55' } =
    props || {};
  const buttonAttr = prepareButtonAttrs(
    button?.link,
    button?.title,
    button?.targetBlank
  );
  return isForm ? (
    <GridItem
      breakpoints={{
        desktop: { col: 12 },
        tablet: { col: 12 },
        mobile: { col: 12 },
      }}
    >
      <SubscriptionForm />
    </GridItem>
  ) : (
    <div className={cnBlogPageBanner()} style={{ backgroundColor: color }}>
      <div className={cnBlogPageBanner('Content')}>
        {title && (
          <Typography.Title size="lg" className={cnBlogPageBanner('Title')}>
            {title}
          </Typography.Title>
        )}
        {text && (
          <Typography.Text size="l" className={cnBlogPageBanner('Text')}>
            {text}
          </Typography.Text>
        )}
        {Object.keys(buttonAttr).length > 0 && (
          <Button
            icon={IconArrowRight}
            className={cnBlogPageBanner('Button')}
            {...buttonAttr}
          />
        )}
      </div>
      {picture && (
        <div className={cnBlogPageBanner('Image')}>
          <Picture {...picture} />
        </div>
      )}
      {Object.keys(buttonAttr).length > 0 && (
        <Button
          icon={IconArrowRight}
          className={cnBlogPageBanner('Button-Mobile')}
          {...buttonAttr}
        />
      )}
    </div>
  );
};
